/**
 * @typedef {'SERVICE_24_HOURS'
 *           |'TOWING_SERVICE'
 *           |'CAR_REPLACEMENT_SERVICE'
 *           |'EXPRESS_SERVICE'
 *           |'VEHICLE_PREPARATION_INT'
 *           |'VEHICLE_PREPARATION_EXT'
 *           |'CAR_RENTAL'
 *           |'VEHICLE_REGISTRATION'
 *           |'COLLECTION_AND_DELIVERY_SERVICE'
 *           |'MASTER_WORKSHOP'
 *           |'BREAKDOWN_SERVICE'
 *           |'TIRE_STORAGE'
 *           |'TIRE_SALE'
 *           |'ORIGINAL_VEHICLE_PARTS'
 *           |'ACCIDENT_ASSISTANCE'
 *           |'SALE_OF_ACCESSORIES'} GENERAL_SERVICES
 */

/**
 * @const GENERAL_SERVICES_NAMES
 * @type {Record<GENERAL_SERVICES, GENERAL_SERVICES>}
 *
 * @description general services name items from dealer service api
 */
export const GENERAL_SERVICES_NAMES = {
  SERVICE_24_HOURS: 'SERVICE_24_HOURS',
  TOWING_SERVICE: 'TOWING_SERVICE',
  CAR_REPLACEMENT_SERVICE: 'CAR_REPLACEMENT_SERVICE',
  EXPRESS_SERVICE: 'EXPRESS_SERVICE',
  VEHICLE_PREPARATION_INT: 'VEHICLE_PREPARATION_INT',
  VEHICLE_PREPARATION_EXT: 'VEHICLE_PREPARATION_EXT',
  CAR_RENTAL: 'CAR_RENTAL',
  VEHICLE_REGISTRATION: 'VEHICLE_REGISTRATION',
  COLLECTION_AND_DELIVERY_SERVICE: 'COLLECTION_AND_DELIVERY_SERVICE',
  MASTER_WORKSHOP: 'MASTER_WORKSHOP',
  BREAKDOWN_SERVICE: 'BREAKDOWN_SERVICE',
  TIRE_STORAGE: 'TIRE_STORAGE',
  TIRE_SALE: 'TIRE_SALE',
  ORIGINAL_VEHICLE_PARTS: 'ORIGINAL_VEHICLE_PARTS',
  ACCIDENT_ASSISTANCE: 'ACCIDENT_ASSISTANCE',
  SALE_OF_ACCESSORIES: 'SALE_OF_ACCESSORIES',
};
